import * as d3 from "d3";
import {
    colonAnnotation,
    numberFormat,
    axisTextDim4,
    colourScheme,
    createAxis, getTimeFormatter, addGridlines
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox,gridflag) {

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(response => {
        let data = resData

        // Nest the entries by symbol
        var states = d3.nest().key(function (d) {
            return d.dim1_name;
        }).sortKeys(d3.ascending).entries(data)

        console.log(states)

        // Nest the entries by symbol
        var dNest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim3_name;
            })
            .entries(data);

        var legendtext = dNest[0].values.map(function (d) {
            return d.key
        })

        console.log("legendtext", legendtext)

        console.log("value of dNest",dNest)
        console.log("color",colourScheme(chart.colourscheme1))

        dNest.forEach(function (group) {
            group.values.forEach(function (innerGroup) {
                innerGroup.values.forEach(function (d) {
                    console.log("value of before d.dim", d.dim2_name);

                    // Check if the format is YYYY-MM (assuming it's a date)
                    if (/^\d{4}-\d{2}$/.test(d[chart.x1DataFieldName])) {
                        d[chart.x1DataFieldName] = new Date(d[chart.x1DataFieldName]);
                        console.log("value of d.dim", d[chart.x1DataFieldName]);
                    }
                    d.metric1 = +d.metric1;
                });
            });
        });

        const dim4Names = data.map(d => d.dim4_name);
        const firstDim4Name = dim4Names[0];

        let value1;
        let rang;

        switch (chart.x1D3ScaleType) {
            case "linearScale":
                value1 =[0, d3.max(data, d => d[chart.x1DataFieldName])];
                rang = [0, chart.width];
                break;

            case "bandScale":
                value1 = data.map(d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            case "timeScale":
                value1 = d3.extent(data, d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            default:
                // Handle any other cases or provide a default behavior
                console.error("Invalid x1D3ScaleType:", chart.x1D3ScaleType);
        }

        console.log("value of chart.x1D3ScaleType", chart.x1D3ScaleType);

        if (value1 && rang) {

            var AxisScaleType = "timeScale";
            var linearScale = "linearScale";

            var x = createAxis(chart.x1D3ScaleType).domain(value1).range(rang);
            var y = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);
            var y2 = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);
            var xAxis;
            var yAxis;
            var y2Axis;

            console.log("firstDim4Name",firstDim4Name)
            var formatTime = getTimeFormatter(firstDim4Name)

            console.log("formatTime",formatTime)
            if(AxisScaleType == chart.x1D3ScaleType) {
                // Define the axes
                xAxis = d3.axisBottom(x).tickFormat(formatTime);
            }
            else if(linearScale==chart.x1D3ScaleType)
            {
                xAxis = d3.axisBottom(x).tickFormat(numberFormat);
            }
            else{
                xAxis = d3.axisBottom(x)
            }

            if(AxisScaleType == chart.y1D3ScaleType) {
                yAxis = d3.axisLeft(y).tickFormat(formatTime);
            }
            else
            {
                yAxis = d3.axisLeft(y).tickFormat(numberFormat);
            }
            y2Axis = d3.axisRight(y2).tickFormat(numberFormat);

            if (checkbox == false) {
                var div = d3.select(divId)
                div.selectAll("*").remove();

                // Adds the canvas
                div = d3.select(divId).selectAll("svg")
                    .data(dNest)
                    .enter()
                    .append("svg")
                    .attr("width", chart.width + chart.margin.right+ chart.margin.left )
                    .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                    .attr("font", "Arial")
                    .style("font-size", "14px")
                    .append("g")
                    .attr("transform",
                        "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                    .attr("id", function (d) {
                        console.log("div ", d.key);
                        return d.key;
                    })

                states.forEach(function (d) {
                    //CSS.escape(id) - will escape special character in id/key
                    var div = d3.select("#" + CSS.escape(d.key));

                    y.domain([
                        (function() {
                            var minVal = d3.min(d.values, function(d) {
                                return d[chart.y1DataFieldName];
                            });
                            return (minVal < 0) ? minVal : 0;
                        })(),
                        d3.max(d.values, function(d) {
                            return d[chart.y1DataFieldName]; // Maximum value in the data
                        })
                    ]);
                    y2.domain([
                        (function() {
                            var minVal = d3.min(d.values, function(d) {
                                return d.metric2;
                            });
                            return (minVal < 0) ? minVal : 0;
                        })(),
                        d3.max(d.values, function(d) {
                            return d.metric2; // Maximum value in the data
                        })
                    ]);
                    if (gridflag === true) {
                        addGridlines(div, x, y, chart);
                    }
                    // Add the div for the tooltip
                    var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);

                    var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

                    // Add the X Axis
                    div.append("g")
                        .attr("class", "x axis")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(xAxis)
                        .selectAll("text") //style for x axis text
                        .style("text-anchor", "middle")
                        .attr("dx", "0em")
                        .attr("dy", "0.9em")
                    //.attr("transform", "rotate(-45)");  // Rotate the text by -45 degrees

                    //adding axis labels
                    div.append("text")
                        .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 15) + ")")
                        .style("text-anchor", "middle")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        .text(chart.x1AxisDisplayName);

                    // Add the Y Axis
                    div.append("g").attr("class", "y axis").call(yAxis);

                    div.append("text")
                        .attr("transform", "rotate(-90)")
                        .attr("x", -chart.height/2)
                        .attr("y", 65)
                        .attr("dy", "-8em")
                        .style("text-anchor", "middle")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        // .style('display', 'none')
                        .text(chart.y1AxisDisplayName);

                    div.append("g")
                        .append("text")
                        .attr("x", -40)
                        .attr("y", chart.height / 1.5)
                        .attr("dy", "-9em")
                        .attr("text-anchor", "start")
                        .attr("font-size", "1.1em")
                        //  .style("fill",function(d) { return color(d.key) })
                        .text(function (d) {
                            return d.key
                        });
                    div.append("g").attr("class", "y2 axis")
                        .attr("transform", "translate(" + chart.width + ",0)")
                        .call(y2Axis)
                        .append("text")
                        .attr("x", chart.height/2)
                        .attr("y", -chart.margin.left) // Adjust the y position based on your requirements
                        .attr("dy", "1em") // Adjust the dy attribute to fine-tune the text positioning
                        .style("text-anchor", "middle")
                        .attr("font-size", "15px")
                        .attr("transform", "rotate(90)")
                        .style('fill', 'blue')
                        .text(chart.y2AxisDisplayName);

                    var lines = div.selectAll(".line1")
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("path")
                        .attr("class", function (d) {
                            // Add a class based on the line type (you can customize this logic)
                            return "line1 " + d.key.replace(/\s+/g, '');
                        })
                        .style("stroke", function (d) {
                            return d.key == '' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                        })
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName]);
                                })
                                .y(d => {
                                    return y(+d.metric1);
                                });

                            return line(d.values);
                        })
                    console.log(lines)
                    // Add the dots for the tooltip
                    div.selectAll("dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d[chart.y1DataFieldName]);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == 'accidents' ? "blue" : d.dim3_name == 'Fatal' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                        })
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function (d) {
                            div1.transition()
                                .duration(200)
                                .style("opacity", .9);
                            div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                chart.y2MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName]))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function () {
                            div1.transition().duration(500).style("opacity", 0);
                        });

                    var line2 = div.selectAll(".line")
                        .data(function (d) {
                            console.log('dichh',d.values)
                            return d.values;
                        })
                        .enter()
                        .append("path")
                        .attr("class", function (d) {
                            // Add a class based on the line type (you can customize this logic)
                            return "line " + d.key.replace(/\s+/g, '');
                        })
                        .style("stroke", "black")
                        .attr("stroke-width", 3)
                        .style("stroke-dasharray", ("3, 3"))
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName]);
                                })
                                .y(d => {
                                    return y2(+d.metric2);
                                });

                            return line(d.values);
                        })
                    console.log(line2)

                    div.selectAll("dot1")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y2(d.metric2);
                        })
                        .style("fill", 'black')
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function (d) {
                            div1.transition()
                                .duration(200)
                                .style("opacity", .9);
                            div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric2))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function () {
                            div1.transition().duration(500).style("opacity", 0);
                        });



                    var y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {                     // NEW
                            //  var height = 0;          // NEW
                            var horz = 80 * i;                       // NEW
                            var vert = 260;                        // NEW
                            return 'translate(' + horz + ',' + vert + ')';        // NEW
                        });

                    y1legend.append('circle')
                        .attr('x', 5)
                        .attr('y', chart.height + 2 * chart.margin.bottom)
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                        });

                    y1legend.append('text')
                        .attr('x', 10)
                        .attr('y', chart.height + 2 * chart.margin.bottom + 5)
                        .attr('dy', '-30em')
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key.substring(0, 10) + "..."
                        })
                })
            } else {
                div = d3.select(divId)
                div.selectAll("*").remove();
                // Adds the canvas
                div = d3.select(divId).selectAll("svg")
                    .data(dNest)
                    .enter()
                    .append("svg")
                    .attr("width", chart.width + chart.margin.left + chart.margin.right)
                    .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                    .attr("font", "Arial")
                    .style("font-size", "14px")
                    .append("g")
                    .attr("transform",
                        "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                    .attr("id", function (d) {
                        console.log("div ", d.key);
                        return d.key;
                    })

                states.forEach(function (d) {
                    //CSS.escape(id) - will escape special character in id/key
                    var div = d3.select("#" + CSS.escape(d.key));
                    //  y.domain([0,d3.max(d.values, function(d) { return d.metric1 })])
                    y.domain([
                        (function() {
                            var minVal = d3.min(data.map((d) => {
                                return d[chart.y1DataFieldName]
                            }));
                            return (minVal < 0) ? minVal : 0;
                        })(),
                        d3.max(data.map((d) => {
                            return d[chart.y1DataFieldName]
                        }))
                    ]);

                    // Add the div for the tooltip
                    var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);
                    var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)
                    if (gridflag === true) {
                        addGridlines(div, x, y, chart);
                    }
                    // Add the X Axis
                    div.append("g")
                        .attr("class", "x axis")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(xAxis)
                        .selectAll("text") //style for x axis text
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", ".15em")
                    //.attr("transform", "rotate(-45)");  // Rotate the text by -45 degrees

                    //adding axis labels
                    div.append("text")
                        .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                        .style("text-anchor", "middle")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        .text(chart.x1AxisDisplayName);

                    // Add the Y Axis
                    div.append("g").attr("class", "y axis").call(yAxis);

                    div.append("text")
                        .attr("transform", "rotate(-90)")
                        .attr("x", -40)
                        .attr("y", 65)
                        .attr("dy", "-8em")
                        .style("text-anchor", "end")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        // .style('display', 'none')
                        .text(chart.y1AxisDisplayName);

                    div.append("g")
                        .append("text")
                        .attr("x", -40)
                        .attr("y", chart.height / 1.5)
                        .attr("dy", "-9em")
                        .attr("text-anchor", "start")
                        .attr("font-size", "1.1em")
                        //  .style("fill",function(d) { return color(d.key) })
                        .text(function (d) {
                            return d.key
                        });

                    // Loop through each symbol / key
                    var lines = div.selectAll(".line")
                        .data(function (d) {
                            return d.values
                        })
                        .enter()
                        .append("path")
                        .attr("class", "line")
                        .style("stroke", function (d) { // Add the colours dynamically
                            return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                        })
                        // .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName])
                                })
                                .y(d => {
                                    return y(+d[chart.y1DataFieldName])
                                })

                            return line(d.values)
                        })

                    console.log(lines)
                    // Add the dots for the tooltip
                    div.selectAll("dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d[chart.y1DataFieldName]);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == 'accidents' ? "blue" : d.dim3_name == 'Fatal' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                        })
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function (d) {
                            div1.transition()
                                .duration(200)
                                .style("opacity", .9);
                            div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                chart.y2MetricTooltip + colonAnnotation + numberFormat(d[chart.y1DataFieldName]))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function () {
                            div1.transition().duration(500).style("opacity", 0);
                        });

                    var y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {                     // NEW
                            //  var height = 0;          // NEW
                            var horz = 100 * i;                       // NEW
                            var vert = 240;                        // NEW
                            return 'translate(' + horz + ',' + vert + ')';        // NEW
                        });

                    y1legend.append('circle')
                        .attr('x', 5)
                        .attr('y', chart.height + 2 * chart.margin.bottom)
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                        });

                    y1legend.append('text')
                        .attr('x', 10)
                        .attr('y', chart.height + 2 * chart.margin.bottom + 5)
                        .attr('dy', '-30em')
                        .style('font-size', '12px')
                        .text(function (d) {
                            // return d.key.substring(0, 10) + "..."
                            return axisTextDim4(d.key)
                        })
                })
            }
        }
    // })
}
